module.exports = __webpack_public_path__ + "img/howtouse06.77ff674d.png";